"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useConnectUser = void 0;
/* eslint-disable @typescript-eslint/explicit-function-return-type */
const react_1 = __importDefault(require("react"));
const use_plugin_1 = require("@app/util/hooks/use-plugin");
const util_1 = require("@app/util");
const store_1 = require("@app/store");
function useConnectUser(client) {
    const { isPluginEnabled } = (0, use_plugin_1.usePlugin)();
    const isChatPluginEnabled = isPluginEnabled('chat');
    const hasChatPermission = util_1.permissionsUtil.canRead('chat');
    const isConnectingRef = react_1.default.useRef(false);
    const [isConnected, setIsConnected] = react_1.default.useState(false);
    const [connectionAttempt, setConnectionAttempt] = react_1.default.useState(1);
    const me = (0, store_1.useRootSelector)((state) => state.me);
    const myId = me?.id;
    const myName = me?.name;
    const myChatToken = me?.chatToken;
    react_1.default.useEffect(() => {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        connectUser();
        let timeoutId = null;
        // console.log({
        //   pluginEnabled: isChatPluginEnabled,
        //   myChatToken,
        //   isConnecting: isConnectingRef.current,
        //   myId,
        //   myName,
        //   isConnected,
        //   hasChatPermission,
        // })
        async function connectUser() {
            if (!isChatPluginEnabled ||
                !myChatToken ||
                isConnectingRef.current ||
                !myId ||
                !myName ||
                isConnected ||
                !hasChatPermission) {
                return;
            }
            isConnectingRef.current = true;
            try {
                const result = await client.connectUser({
                    id: myId,
                    name: myName,
                }, myChatToken);
                setIsConnected(true);
                console.log('client.connectUser success', result);
            }
            catch (error) {
                console.error('client.connectUser failed', { error });
                try {
                    await client.disconnectUser();
                    console.log('client.disconnectUser success');
                }
                catch (error2) {
                    console.error('client.disconnectUser failed', { error: error2 });
                }
                if (connectionAttempt < 15) {
                    timeoutId = setTimeout(() => setConnectionAttempt((current) => current + 1), connectionAttempt * connectionAttempt * 2000);
                }
            }
            isConnectingRef.current = false;
        }
        return () => {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
        };
    }, [
        myId,
        myName,
        client,
        isConnected,
        connectionAttempt,
        hasChatPermission,
        myChatToken,
        isChatPluginEnabled,
    ]);
    react_1.default.useEffect(() => {
        if (!myId && isConnected) {
            setIsConnected(false);
        }
    }, [myId, isConnected]);
    return { isConnected };
}
exports.useConnectUser = useConnectUser;
